<ag-grid-angular
  class="ag-theme-alpine"
  [pagination]="true"
  [serverSideInfiniteScroll]="true"
  [paginationPageSize]="paginationPageSize"
  [cacheBlockSize]="cacheBlockSize"
  [maxBlocksInCache]="maxBlocksInCache"
  [getContextMenuItems]="getContextMenuItems"
  [maxConcurrentDatasourceRequests]="maxConcurrentDatasourceRequests"
  [statusBar]="statusBar"
  [sideBar]="sideBar"
  [rowSelection]="rowSelection"
  [rowGroupPanelShow]="rowGroupPanelShow"
  [pivotPanelShow]="pivotPanelShow"
  [autoGroupColumnDef]="autoGroupColumnDef"
  [enableCellChangeFlash]="true"
  [enableRangeSelection]="false"
  [rowModelType]="rowModelType"
  [columnDefs]="columnDefs"
  [suppressCopyRowsToClipboard]="true"
  [processCellForClipboard]="processCellForClipboard"
  [overlayLoadingTemplate]="overlayLoadingTemplate"
  [pinnedTopRowData]="pinnedTopRowData"
  [defaultColDef]="defaultColDef"
  [rowData]="rowData$ | async"
  [animateRows]="true"
  [rowClassRules]="rowClassRules"
  (selectionChanged)="onSelectionChanged()"
  (filterChanged)="filterChanged($event)"
  (gridReady)="onGridReady($event)"
  (columnMoved)="columnEverythingChanged($event)"
  (columnResized)="columnEverythingChanged($event)"
  (columnPinned)="columnEverythingChanged($event)"
  (columnVisible)="columnEverythingChanged($event)"
></ag-grid-angular>
